module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.net.land.carbon.stock.loss.uncertainty.d50e4453.png").toString();